var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClockIconGrey(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 26,
    viewBox: "0 0 22 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-961 -945) translate(882 850) translate(47 68) translate(32 27) translate(.43 .73)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.518,
    cy: 14.739,
    fill: "#FFF",
    rx: 9.642,
    ry: 9.537
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BCBCBC",
    fillRule: "nonzero",
    d: "M10.706 22.394c1.523 0 2.922-.377 4.197-1.13 1.256-.734 2.255-1.732 2.998-2.993.742-1.262 1.113-2.645 1.113-4.151 0-1.506-.371-2.89-1.113-4.152-.743-1.242-1.742-2.23-2.998-2.965-1.275-.734-2.674-1.101-4.197-1.101-1.523 0-2.921.367-4.197 1.101-1.256.735-2.255 1.723-2.997 2.965-.743 1.262-1.114 2.646-1.114 4.152 0 1.506.371 2.89 1.114 4.15.742 1.262 1.741 2.26 2.997 2.994 1.276.753 2.674 1.13 4.197 1.13zm8.365-14.826c.742.923 1.313 1.93 1.713 3.022.419 1.13.628 2.306.628 3.53 0 1.92-.485 3.699-1.456 5.337-.951 1.6-2.236 2.87-3.854 3.812-1.656.96-3.454 1.44-5.396 1.44-1.941 0-3.74-.48-5.396-1.44-1.618-.941-2.902-2.212-3.854-3.812C.486 17.819 0 16.04 0 14.12s.485-3.7 1.456-5.338c.952-1.6 2.236-2.87 3.854-3.812 1.656-.96 3.455-1.44 5.396-1.44 1.218 0 2.417.216 3.597.65 1.104.414 2.132.988 3.084 1.722l1.684-1.723c.533.433 1.095.989 1.685 1.667L19.07 7.568zm-9.535 7.766v-7.06h2.34v7.06h-2.34zM14.275 0v2.372H7.137V0h7.138z"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIconGrey);
export default __webpack_public_path__ + "static/media/clock_icon_grey.c53dee7fe82a4b8738a3bc4f5581ff25.svg";
export { ForwardRef as ReactComponent };